var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5 9.286"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 4.643l-.271-.292L.673 0 0 .585l3.785 4.058L0 8.7l.673.585 4.056-4.35z"
  })));
}

export default __webpack_public_path__ + "56e05cca84d2cb4def6c69e7fc0f12ac.svg";
export { SvgNavArrowRight as ReactComponent };